import {ModelRepository, RequestMethod} from 'b302-frontend-library';
import BaseSubjectArea from '../models/SubjectArea';
import {PaginationRequest} from '../requests/Util';

export interface Filters {
    languages: string[];
    levels: string[];
    subject_areas: string[];
}

export interface FilterParams extends PaginationRequest {
    search?: string;
    languages?: string[];
    levels?: string[];
    subject_areas?: string[];
    order_by?: string;
    direction?: string;
}

// TODO: REMOVE AND FIX
export interface SubjectArea extends BaseSubjectArea {
    subject_area_id: number;
}

class SubjectAreaRepository extends ModelRepository<BaseSubjectArea> {

    public constructor() {
        super('/subject-areas');
    }

    public all(): Promise<SubjectArea[]> {
        return this.request<SubjectArea[]>('/subject-areas/all', RequestMethod.GET).send();
    }

    public allPaginated(params?: FilterParams) {
        return this.requestWithOptions<SubjectArea[]>(this.url(), RequestMethod.GET, { params }).sendPagination();
    }

    public getFilters() {
        return this.request<Filters>(this.url('/filters'), RequestMethod.GET).sendRaw();
    }
}

export default SubjectAreaRepository;
